import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { baseUrl } from '../utils';
import axios from 'axios';

const initialState = {
  loading: false,
  data: {
    content: [],
  },
  newReqState: {
    loading: false,
  },
  member: {
    isSearchLoaded: false,
    isSearchLoading: false,
    data: null,
    error: false,
  },
  visitLookup: {
    loading: false,
    data: null,
    error: null,
  },
  otpVerification: {
    loading: false,
    data: null,
    error: null,
  },
  documentUpload: {
    loading: false,
    data: null,
    error: null,
  },
  claimsList: {
    loading: false,
    data: null,
    error: null,
  },
};

export const createManualClaim = createAsyncThunk(
  'createManualClaim',
  async ({ formData, openNotificationWithIcon, navigate }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios({
        method: 'POST',
        url: `${baseUrl}/provider/pharmacy`,
        data: formData,
        headers: {
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
      openNotificationWithIcon('success', data.message);
      navigate('/');
    } catch (error) {
      openNotificationWithIcon('error', error.message);
    }
  },
);

export const deletePrescription = createAsyncThunk(
  'prescriptionDelete',
  async ({ id, openNotificationWithIcon }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios.delete(`${baseUrl}/provider/prescription/delete/${id}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      openNotificationWithIcon('success', data.message);
      return id;
    } catch (error) {
      console.log(error);
      openNotificationWithIcon('error', error.message);
    }
  },
);

export const getPharmacyClaimList = createAsyncThunk(
  'getPharmacyClaimList/new',
  async ({ page }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios.get(
        `${baseUrl}/provider/pharmacy/list?page=${page}&size=${6}&sort=createdTimestamp,desc`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const getPharmacyManualClaimList = createAsyncThunk(
  'getPharmacyManualClaimList/new',
  async ({ page }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios.get(
        `${baseUrl}/provider/pharmacy/manual-claim/list?page=${page}&size=${6}&sort=createdTimestamp,desc`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const initiatePharmacyClaim = createAsyncThunk(
  'initiatePharmacyClaim/new',
  async ({ updatedValue, navigate, openNotificationWithIcon }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios.post(`${baseUrl}/provider/pharmacy/claim`, updatedValue, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.api.responseCode === 2010) {
        openNotificationWithIcon('success', data.message);
        navigate('/');
      } else {
        openNotificationWithIcon('error', data.message);
      }
      return data;
    } catch (error) {
      openNotificationWithIcon('error', error.message);
      console.log(error);
    }
  },
);

// NEW API: Pharmacy Visit Lookup
export const pharmacyVisitLookup = createAsyncThunk(
  'pharmacyVisitLookup',
  async ({ visitId, openNotificationWithIcon }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const { data } = await axios.post(
        `${baseUrl}/pharmacy/lookup/visit/${visitId}`,
        {},
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.api?.responseCode === 2010) {
        openNotificationWithIcon && openNotificationWithIcon('success', data.message);
      }
      return data;
    } catch (error) {
      openNotificationWithIcon && openNotificationWithIcon('error', error.message);
      throw error;
    }
  },
);

// NEW API: Send OTP to Member
export const sendOtpToMember = createAsyncThunk(
  'sendOtpToMember',
  async ({ visitId, claimData, openNotificationWithIcon }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      // Create FormData for the request
      // formData.append('data', JSON.stringify(claimData));

      const { data } = await axios.post(
        `${baseUrl}/pharmacy-claim/visit/member-verify/${visitId}`,
        JSON.stringify(claimData),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.api?.responseCode === 2010) {
        openNotificationWithIcon && openNotificationWithIcon('success', 'OTP sent successfully');
      }
      return data;
    } catch (error) {
      openNotificationWithIcon && openNotificationWithIcon('error', error.message);
      throw error;
    }
  },
);
// NEW API: Validate OTP
export const validateOtp = createAsyncThunk(
  'validateOtp',
  async ({ visitId, otp, claimsData,openNotificationWithIcon }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
     const formData = new FormData();
formData.append('data', JSON.stringify(claimsData));

      const { data } = await axios.post(
        `${baseUrl}/pharmacy-claim/validate-otp/${visitId}/${otp}`,
        formData,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.api?.responseCode === 2010) {
        openNotificationWithIcon && openNotificationWithIcon('success', 'OTP validated successfully');
      }
      return data;
    } catch (error) {
      openNotificationWithIcon && openNotificationWithIcon('error', error.message);
      throw error;
    }
  },
);

// NEW API: Upload Documents by Claim ID
export const uploadClaimDocuments = createAsyncThunk(
  'uploadClaimDocuments',
  async ({ claimId, prescription, pharmacyInvoice, openNotificationWithIcon }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      const formData = new FormData();
      if (prescription) {
        formData.append('prescription', prescription);
      }
      if (pharmacyInvoice) {
        formData.append('pharmacy_invoice', pharmacyInvoice);
      }

      const { data } = await axios.post(
        `${baseUrl}/pharmacy-claim/visit/upload/${claimId}`,
        formData,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data.api?.responseCode === 2010) {
        openNotificationWithIcon && openNotificationWithIcon('success', 'Documents uploaded successfully');
      }
      return data;
    } catch (error) {
      openNotificationWithIcon && openNotificationWithIcon('error', error.message);
      throw error;
    }
  },
);

// NEW API: Get Claims List with Filters
export const getClaimsList = createAsyncThunk(
  'getClaimsList',
  async ({ page = 0, size = 20, status, sort = 'createdTimestamp,desc' }) => {
    let token = localStorage.getItem('x-auth-token');
    try {
      let url = `${baseUrl}/claims/list?sort=${sort}&page=${page}&size=${size}`;
      if (status) {
        url += `&status=${status}`;
      }

      const { data } = await axios.get(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const prescriptionSlice = createSlice({
  name: 'prescription',
  initialState: initialState,
  reducers: {
    addMemberError: (state) => {
      state.member.isSearchLoaded = true;
      state.member.error = 'An existing prescription already exists for Member number';
    },
    resetMember: (state) => {
      state.member.isSearchLoading = false;
      state.member.isSearchLoaded = false;
      state.member.data = null;
    },
    resetVisitLookup: (state) => {
      state.visitLookup.loading = false;
      state.visitLookup.data = null;
      state.visitLookup.error = null;
    },
    resetOtpVerification: (state) => {
      state.otpVerification.loading = false;
      state.otpVerification.data = null;
      state.otpVerification.error = null;
    },
    resetDocumentUpload: (state) => {
      state.documentUpload.loading = false;
      state.documentUpload.data = null;
      state.documentUpload.error = null;
    },
  },
  extraReducers(builder) {
    // Existing reducers
    builder.addCase(getPharmacyClaimList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPharmacyClaimList.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.data = action.payload?.result;
      } else {
        state.data = initialState.data;
      }
    });
    builder.addCase(getPharmacyClaimList.rejected, (state) => {
      state.loading = false;
      state.data = initialState.data;
    });

    builder.addCase(getPharmacyManualClaimList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPharmacyManualClaimList.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.result) {
        state.data = action.payload?.result;
      } else {
        state.data = initialState.data;
      }
    });
    builder.addCase(getPharmacyManualClaimList.rejected, (state) => {
      state.loading = false;
      state.data = initialState.data;
    });

    builder.addCase(deletePrescription.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePrescription.fulfilled, (state, action) => {
      state.loading = false;
      state.data.content = state.data.content.filter(
        (item) => item.prescription_id !== action.payload,
      );
      state.data.property.total_elements = state.data.property.total_elements - 1;
    });

    // NEW API reducers
    // Pharmacy Visit Lookup
    builder.addCase(pharmacyVisitLookup.pending, (state) => {
      state.visitLookup.loading = true;
      state.visitLookup.error = null;
    });
    builder.addCase(pharmacyVisitLookup.fulfilled, (state, action) => {
      state.visitLookup.loading = false;
      state.visitLookup.data = action.payload;
      state.visitLookup.error = null;
    });
    builder.addCase(pharmacyVisitLookup.rejected, (state, action) => {
      state.visitLookup.loading = false;
      state.visitLookup.data = null;
      state.visitLookup.error = action.error.message;
    });

    // Send OTP to Member
    builder.addCase(sendOtpToMember.pending, (state) => {
      state.otpVerification.loading = true;
      state.otpVerification.error = null;
    });
    builder.addCase(sendOtpToMember.fulfilled, (state, action) => {
      state.otpVerification.loading = false;
      state.otpVerification.data = action.payload;
      state.otpVerification.error = null;
    });
    builder.addCase(sendOtpToMember.rejected, (state, action) => {
      state.otpVerification.loading = false;
      state.otpVerification.data = null;
      state.otpVerification.error = action.error.message;
    });

    // Validate OTP
    builder.addCase(validateOtp.pending, (state) => {
      state.otpVerification.loading = true;
      state.otpVerification.error = null;
    });
    builder.addCase(validateOtp.fulfilled, (state, action) => {
      state.otpVerification.loading = false;
      state.otpVerification.data = action.payload;
      state.otpVerification.error = null;
    });
    builder.addCase(validateOtp.rejected, (state, action) => {
      state.otpVerification.loading = false;
      state.otpVerification.data = null;
      state.otpVerification.error = action.error.message;
    });

    // Upload Documents
    builder.addCase(uploadClaimDocuments.pending, (state) => {
      state.documentUpload.loading = true;
      state.documentUpload.error = null;
    });
    builder.addCase(uploadClaimDocuments.fulfilled, (state, action) => {
      state.documentUpload.loading = false;
      state.documentUpload.data = action.payload;
      state.documentUpload.error = null;
    });
    builder.addCase(uploadClaimDocuments.rejected, (state, action) => {
      state.documentUpload.loading = false;
      state.documentUpload.data = null;
      state.documentUpload.error = action.error.message;
    });

    // Get Claims List
    builder.addCase(getClaimsList.pending, (state) => {
      state.claimsList.loading = true;
      state.claimsList.error = null;
    });
    builder.addCase(getClaimsList.fulfilled, (state, action) => {
      state.claimsList.loading = false;
      state.claimsList.data = action.payload;
      state.claimsList.error = null;
    });
    builder.addCase(getClaimsList.rejected, (state, action) => {
      state.claimsList.loading = false;
      state.claimsList.data = null;
      state.claimsList.error = action.error.message;
    });
  },
});

export const { 
  resetMember, 
  addMemberError, 
  resetVisitLookup, 
  resetOtpVerification, 
  resetDocumentUpload 
} = prescriptionSlice.actions;

export default prescriptionSlice.reducer;